import { createSelector } from '@ngrx/store';
import { get } from '~gc/shared/utils/func';
import { featureState } from './feature.name';

export const calendarState = createSelector(featureState, get('calendar'));

export const calendarTitle = createSelector(calendarState, get('title'));
export const calendarDate = createSelector(calendarState, get('date'));
